import { api } from 'redux/api/index.api';
import { getBusinessOrganizationVersion } from 'utils/constants';

export const dashboardApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchPowerBiAuth: builder.query({
      query: ({ organizationId, workspaceId, projectId }) => ({
        method: 'POST',
        url: `${getBusinessOrganizationVersion()}/organizations/${organizationId}/dashboard/powerbi`,
        body: {
          workspace_id: workspaceId,
          project_id: projectId,
        },
      }),
      transformResponse: response => ({
        embedUrl: response.embed_url,
        repordId: response.id,
        token: response.token,
      }),
    }),
  }),
  overrideExisting: 'throw',
});

export const { useFetchPowerBiAuthQuery } = api;
